import $api from '@/http/api'
import $common from '../common'

export default {
	namespaced: true,
	state: {
		servicePackDetail: {},
		serviceChild: {} // 正在进行预约操作的服务项信息
	},
	getters: {
		getDetail: state => $common.storeGetterSessionCommon(state, 'servicePackDetail', 'object'),
		getServiceChild: state => $common.storeGetterSessionCommon(state, 'serviceChild', 'object')
	},
	mutations: {
		['SET_SERVICE_PACK_DETAIL'](state, val) {
			state.servicePackDetail = val
			window.sessionStorage.setItem('servicePackDetail', JSON.stringify(val))
		},
		['SET_SERVICE_CHILD'](state, val) {
			state.serviceChild = val
			window.sessionStorage.setItem('serviceChild', JSON.stringify(val))
		}
	},
	actions: {
		/**
		 * @method 获取详情
		 * @params { string } id 服务id
		 * @params { cb } 回调方法
		 */
		async apiGetServiceDetail({ commit }, { params, cb }) {
			const res = await $api.servicePack.getDetail(params)
			if (!res.code) {
				commit('SET_SERVICE_PACK_DETAIL', res.data)
				cb && cb(res.data)
			}
		}
	}
}
